import React from 'react';
import Hero from '../components/Hero';
import { AboutSection, StatsSection, ExperienceTimeline, ServicesSection, ISOSection, IndustriesSection, InsuranceCTA, TeamGallery } from '../components/Sections';
import { FAQSection, TestimonialsSection, PartnersSection, FacebookFeed } from '../components/ExtraSections';
import { useSiteSettings } from '../context/SiteSettingsContext';

const Home = () => {
  const { settings } = useSiteSettings();
  const show = (key) => settings?.[key] !== false; // default true
  return (
    <div>
      <Hero />
      <AboutSection />
      {show('section_team_gallery') && <TeamGallery />}
      {show('section_stats') && <StatsSection />}
      <ServicesSection />
      {show('section_facebook_feed') && <FacebookFeed />}
      {show('section_experience') && <ExperienceTimeline />}
      {show('section_iso') && <ISOSection />}
      {show('section_industries') && <IndustriesSection />}
      {show('section_insurance_cta') && <InsuranceCTA />}
      {show('section_testimonials') && <TestimonialsSection />}
      {show('section_faq') && <FAQSection />}
      {show('section_partners') && <PartnersSection />}
    </div>
  );
};

export default Home;
